import React from 'react';
import WalletIcon from '../../UI/SVG/WalletIcon';
import UbisoftLogo from '../../UI/SVG/UbisoftLogo';
import ArrowIcon from '../../UI/SVG/ArrowIconProps.';
import Fixedprice from '../FixedPrice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { getAmount } from '../../../utils';

interface IWalletTopBannerProps {
  title: string;
  targetAmount: string | number;
  originAmount?: string | number;
}

const WalletTopBanner = ({
                           title,
                           targetAmount,
                           originAmount
                         }: IWalletTopBannerProps) => {
  const hasOriginAmount = typeof originAmount !== 'undefined';
  const app = useSelector((state: RootState) => state.app);

  return (
    <div className='wallet-top-banner'>
      <div className='left'>
        <div className='background'>
          <UbisoftLogo fill='white' />
        </div>
        <div className='left__inner'>
          <div className='icon'>
            <WalletIcon fill='white' />
          </div>
          <div className='content'>{title}</div>
        </div>
      </div>
      <div className={`right ${hasOriginAmount ? 'with-origin' : ''}`}>
        {hasOriginAmount && (
          <div className='fixed-price-container origin-amount'>
            <Fixedprice price={getAmount(originAmount)} />
          </div>
        )}
        {hasOriginAmount && <ArrowIcon direction='bottom' fill='#35c1cf' />}

        <div className='fixed-price-container target-amount'>
          <Fixedprice price={getAmount(targetAmount)} />
        </div>
      </div>
    </div>
  );
};

export default WalletTopBanner;
